import React from "react";
import "./ForcedLogoutModal.css";

const ForceLogoutModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Too Many Active Sessions</h2>
        <p>
          You have exceeded the maximum number of active sessions. Do you want
          to proceed?
        </p>
        <div className="modal-buttons">
          <button className="confirm-btn" onClick={onConfirm}>
            Yes
          </button>
          <button className="cancel-btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForceLogoutModal;
